export const MAX_ZOOM = 5;
export const MIN_ZOOM = 0.1;
export const SCROLL_SENSITIVITY = 0.0005;

export const CANVAS_HEITHT = 900;
export const CANVAS_WIDTH = 1600;

export const BUBBLE_CENTER_RADIUS = 5;
export const BUBBLE_END_RADIUS = 15;

export const BUBBLE_BLUE = 'rgb(29, 42, 55)';
export const BUBBLE_YELLOW = 'rgb(229, 170, 68)';
export const BUBBLE_RED = 'rgb(201, 56, 74)';
export const BUBBLE_GREEN = 'rgb(45, 164, 77)';
export const BUBBLE_PURPLE = '#b236eb';

export const BUBBLE_BLUE_TRANS = 'rgba(29, 42, 55, 0.4)';
export const BUBBLE_YELLOW_TRANS = 'rgba(229, 170, 68, 0.4)';
export const BUBBLE_RED_TRANS = 'rgb(201, 56, 74, 0.4)';
export const BUBBLE_GREEN_TRANS = 'rgba(45, 164, 77, 0.4)';

export const BUBBLE_YELLOW_BG = 'rgba(229, 170, 68, 0.1)';
export const BUBBLE_GREEN_BR = 'rgba(45, 164, 77, 0.1)';
